import Env from "config/environment";

// Print out current Git SHA to expdite determining what application bundle
// is currently being run in a given environment.
console.info(`⭐️ Notarize Web Release: ${Env.releaseName}`); // eslint-disable-line no-console
